export default __webpack_public_path__ + "static/10_soft-light-d12af7be210ea6ac210c3b155abd1e34.png";